var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"theMapAutofitButton"}},[(!_vm.MapViewStore.autofit)?_c('div',[_c('McButton',{staticClass:"m-0 boxShadow",attrs:{"onmap":"","variant":"primary","icon":['fad', 'wand-magic'],"text":_vm.$t('map.enableautofit')},on:{"click":_vm.enableAutofit}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }